export default "__VITE_ASSET__2fd173d3__"